import { forwardRef } from 'react';

import clsx from 'clsx';

import { container, containerEnter, containerExit } from './Modal.css';
import { ModalContainerProps } from './types';

export interface ModalContainerInternalProps extends ModalContainerProps {
  isExiting?: boolean;
}

export const ModalContainer = forwardRef<HTMLDivElement, ModalContainerInternalProps>(
  ({ size = 400, className, children, isExiting, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(container, isExiting ? containerExit : containerEnter, className)}
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        style={{
          width: typeof size === 'number' ? `${size}px` : size,
          ...style,
        }}
        {...props}
      >
        {children}
      </div>
    );
  },
);

ModalContainer.displayName = 'ModalContainer';
